export default defineNuxtPlugin((_nuxtApp) => {
  // i18n is handled by @nuxtjs/i18n module — see nuxt.config.ts
});
